module.exports = __webpack_public_path__ + "static/img/TUSCANY_OAK.46d5a68.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/TUSCANY_OAK.jpg
// module id = fEgE
// module chunks = 0